<div
  [matTooltip]="'You can not reject candidates with different statuses.'"
  [matTooltipDisabled]="!!isNotDisabled"
>
  <div
    class="ripple-container"
    matRipple
    [class.disabled]="!isNotDisabled"
    [matRippleDisabled]="!isNotDisabled"
    data-cy="batch-toolbar-reject-selected-candidates-button"
  >
    <mat-icon data-cy="batch-toolbar-reject-selected-candidates-icon">
      person_add_disabled
    </mat-icon>
    Reject
  </div>
</div>
